// Empty module for Turbopack browser fallbacks.
export default {};
